import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import styles from './tabs.styl'

export default class Tabs extends Component {
  static propTypes = {
    links: PropTypes.array,
    location: PropTypes.object
  }

  render() {
    const { links, location } = this.props
    const tabsItems = links.map((item, index) => {
      const active = item.path === location.pathname ? ' active' : ''

      return (
        <li className={styles.item} key={index}>
          <Link className={`${styles.link} ${active}`} to={item.path}>{item.label}</Link>
        </li>
      )
    })

    return (
      <ul className={styles.list}>
        {tabsItems}
      </ul>
    )
  }
}
